import ShadeContainer from './ShadeContainer';
import Page from './Page';
import QuoteInfoPage from './QuoteInfoPage';

function sortShades(to_sort) {
	const rooms = {};

	to_sort.forEach((shade) => {
		if (rooms[shade.val('room_name')] === undefined) {
			rooms[shade.val('room_name')] = [shade];
		} else {
			rooms[shade.val('room_name')].push(shade);
		}
	});
		
	return (

		Object.keys(rooms)
			  .sort((room_name_a, room_name_b) => ((`${room_name_a}`).toLowerCase() > (`${room_name_b}`).toLowerCase() ? 1 : -1))
			  .map((room_name) => rooms[room_name])
			  .reduce((acc, shades_arr) => acc.concat(
			  		shades_arr.sort((shade_a, shade_b) => ((`${shade_a.val('shade_name')}`).toLowerCase() > (`${shade_b.val('shade_name')}`).toLowerCase() ? 1 : -1))
			  	), [])
				 
	);
}

export default function PrintQuote(props) {
	const shades = sortShades(props.quote.shades);
							
	const pages = [
		<QuoteInfoPage key="quote-info" newQuote={props.newQuote} quote={props.quote} shades={shades} isPrint={props.isPrint} />
	];

	let pageindex = 0;
	shades.forEach((shade) => {
		pages.push(
			<Page key={pageindex}>

				<ShadeContainer key={shade.sequenceId} shade={shade} quote={props.quote} currencyData={props.currencyData} />
			</Page>
		);
		pageindex++;
	});

	return (
		<div key={`p${pages.keys}`} className="print-only">
			{ pages }
		</div>
	);
}
